import script from "./ExcludedAccountsModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExcludedAccountsModal.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__